import { useState, useCallback } from "react";
import { teacherAPI } from "../services/api";

export const useTeachers = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtering, setFiltering] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 15,
    total: 0,
  });

  const fetchTeachers = useCallback(async (page = 1, filters = {}, isFiltering = false) => {
    try {
      if (isFiltering) {
        setFiltering(true);
      } else {
        setLoading(true);
      }
      
      const params = {
        page,
        per_page: 15,
        ...filters,
      };

      Object.keys(params).forEach((key) => {
        if (params[key] === "" || params[key] === undefined) {
          delete params[key];
        }
      });

      const response = await teacherAPI.getAll(params);
      
      if (response.data && typeof response.data === "object" && response.data.data) {
        setTeachers(response.data.data);
        setPagination({
          current_page: response.data.current_page,
          last_page: response.data.last_page,
          per_page: response.data.per_page,
          total: response.data.total,
        });
      } else if (Array.isArray(response.data)) {
        setTeachers(response.data);
        setPagination({
          current_page: 1,
          last_page: 1,
          per_page: response.data.length,
          total: response.data.length,
        });
      }
    } catch (error) {
      console.error("Error fetching teachers:", error);
      setTeachers([]);
    } finally {
      setLoading(false);
      setFiltering(false);
    }
  }, []);

  const createTeacher = async (data) => {
    return await teacherAPI.create(data);
  };

  const updateTeacher = async (id, data) => {
    return await teacherAPI.update(id, data);
  };

  const deleteTeacher = async (id) => {
    return await teacherAPI.delete(id);
  };

  const getTeacherById = async (id) => {
    return await teacherAPI.getById(id);
  };

  return {
    teachers,
    loading,
    filtering,
    pagination,
    fetchTeachers,
    createTeacher,
    updateTeacher,
    deleteTeacher,
    getTeacherById,
  };
};
